import { SVG, type Svg } from "@svgdotjs/svg.js";

export const fitSvgToTightViewbox = (svg: Svg, paddingPx = 3) => {
    const bbox = svg.bbox();
    const viewX = Math.floor(bbox.x - paddingPx);
    const viewY = Math.floor(bbox.y - paddingPx);
    const viewW = Math.ceil(bbox.width + 2 * paddingPx);
    const viewH = Math.ceil(bbox.height + 2 * paddingPx);
    svg.viewbox(viewX, viewY, viewW, viewH);
    svg.size(viewW, viewH);
};

export const createBaseSvg = (w: number, h: number) => {
    const svg = SVG().size(w, h);
    svg.viewbox(0, 0, w, h);
    return svg;
};

export const rotateSvgMarkup90ccw = (svgMarkup: string, wPx: number, hPx: number) => {
    const openTagEnd = svgMarkup.indexOf(">");
    const closeIndex = svgMarkup.lastIndexOf("</svg>");
    const inner = svgMarkup.slice(openTagEnd + 1, closeIndex);

    const rotated = `<?xml version="1.0" encoding="UTF-8"?>
        <svg width="${hPx}" height="${wPx}" viewBox="0 0 ${hPx} ${wPx}" xmlns="http://www.w3.org/2000/svg">
          <g transform="rotate(90) translate(0,-${hPx})">${inner}</g>
        </svg>`;

    return { svg: rotated, wPx: hPx, hPx: wPx } as const;
};
